import {
  createTheme,
  TextField,
  ThemeProvider,
  Tooltip,
  withStyles
} from '@material-ui/core';
import React from 'react';

import styles from './styles';
import clsx from 'clsx';
import getNestedValue from '../../utils/getNestedValue';
import Optional from '../../utils/optional';

const DataInputBox = ({
  name,
  label,
  handleBlur,
  handleChange,
  values = {},
  errors = {},
  classes,
  width = 200,
  disabled = false,
  infoIcon = false,
  infoIconText,
  rows = 1,
  isValueNested = false,
  multiline = true
}) => {
  const theme = createTheme({
    overrides: {
      MuiOutlinedInput: {
        root: { backgroundColor: '#FFF' },
        input: {
          width,
          padding: '12px',
          height: '23px',
          backgroundColor: '#FFF'
        },
        multiline: {
          backgroundColor: '#FFF'
        },
        notchedOutline: {
          top: ' 0px'
        }
      }
    }
  });

  const value = isValueNested
    ? getNestedValue(values, name)
    : Optional(values[name]).or('');

  return (
    <div
      className={classes.root}
      style={{ minWidth: width ? `${width}px` : '260px' }}
    >
      <div className={classes.label}>
        {label}
        {infoIcon && (
          <Tooltip title={infoIconText}>
            <i className={clsx('fas fa-info-circle', classes.infoIcon)}></i>
          </Tooltip>
        )}
      </div>
      <ThemeProvider theme={theme}>
        <TextField
          variant="outlined"
          margin="dense"
          name={name}
          value={value}
          onBlur={handleBlur}
          onChange={handleChange}
          error={Boolean(errors[name])}
          disabled={disabled}
          multiline={multiline}
          minRows={rows}
          inputProps={{
            autoComplete: 'off',
            'data-lpignore': true
          }}
        ></TextField>
      </ThemeProvider>
    </div>
  );
};

export default withStyles(styles)(DataInputBox);
